import { performGetRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import type { ResponseSuccess } from '../../types.tsx';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (baseUrl: string, key: string): Promise<ResponseSuccess> => {
	const requestUrl = `/rest/api/3/mypreferences?key=${key}`;
	return performGetRequest(requestUrl);
};
